import { useCallback } from 'react';

import { type Clip } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackUploadedAsset = () => {
  const { track } = useAnalyticsUtilities();

  const trackUploadedAsset = useCallback(
    (params: { clipId: Clip['id'] }) => {
      track(`Uploaded an asset`, params, { integrations: { 'Customer.io (Actions)': true, Intercom: true } });
    },
    [track],
  );

  return { trackUploadedAsset };
};
